export const contactLimits = { name: 200, email: 254, company: 300, need: 5000 }

export function validateContact(data: { name: string; email: string; company: string; need: string }) {
  const errors: Record<string, string> = {}
  if (!data.name) errors.name = 'Please enter your name.'
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)) errors.email = 'Please enter a valid work email.'
  if (!data.company) errors.company = 'Please enter your company.'
  if (data.need.length < 20) errors.need = 'A sentence or two helps us prepare for the conversation.'
  for (const key of ['name', 'email', 'company', 'need'] as const) {
    if (data[key].length > contactLimits[key]) errors[key] = `Please use ${contactLimits[key]} characters or fewer.`
  }
  return errors
}
